import { VENTURES } from "../data/content";
import { Reveal } from "./Reveal";
import { ArrowUpRight } from "lucide-react";

export const Ventures = () => {
  return (
    <section
      id="ventures"
      data-testid="ventures-section"
      className="relative py-24 lg:py-32 bg-[#F8FAFC]"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 mb-16 lg:mb-20">
          <Reveal className="lg:col-span-7">
            <div className="flex items-center gap-4 mb-6">
              <span className="h-px w-10 bg-[#0A192F]/40" />
              <span className="text-xs uppercase tracking-[0.3em] text-[#0A192F]/60">
                Current Ventures
              </span>
            </div>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-[64px] leading-[1.02] tracking-tight text-[#0A192F]">
              Four companies.
              <br />
              One shared thesis.
            </h2>
          </Reveal>
          <Reveal delay={120} className="lg:col-span-5 lg:pt-6">
            <p className="text-lg text-[#475569] leading-relaxed">
              From founding-CEO seat to board director, every venture in Sean's
              active portfolio answers the same question — what does healthcare
              look like when it is engineered with the rigor of modern
              infrastructure?
            </p>
          </Reveal>
        </div>

        <div className="grid lg:grid-cols-12 gap-6 lg:gap-8">
          {VENTURES.map((v, idx) => (
            <Reveal
              key={v.name}
              delay={idx * 110}
              className={`group bg-white border border-black/5 p-8 lg:p-10 transition-all duration-500 hover:-translate-y-1 hover:shadow-2xl cursor-pointer ${
                idx % 4 === 0 ? "lg:col-span-7" : ""
              } ${idx % 4 === 1 ? "lg:col-span-5" : ""} ${
                idx % 4 === 2 ? "lg:col-span-5" : ""
              } ${idx % 4 === 3 ? "lg:col-span-7" : ""}`}
            >
              <div className="flex items-start justify-between mb-12">
                <span className="font-serif text-5xl text-[#0A192F]/15">
                  {v.accent}
                </span>
                <ArrowUpRight
                  className="text-[#0A192F] opacity-0 group-hover:opacity-100 group-hover:-translate-y-1 group-hover:translate-x-1 transition-all duration-300"
                  size={26}
                />
              </div>
              <h3 className="font-serif text-2xl lg:text-3xl text-[#0A192F] mb-2">
                {v.name}
              </h3>
              <div className="text-xs uppercase tracking-[0.25em] text-[#475569] mb-6">
                {v.role} · {v.sector}
              </div>
              <p className="text-[#475569] leading-relaxed">{v.summary}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
